import React from 'react';
import ReactDOM from 'react-dom/client';
import "shared/styles/index.css";
import "shared/styles/style.css";
import "shared/styles/App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from './App';
import { initSessionBridge } from 'shared/utils/sessionBridge';

// Synchronize cross-subdomain session before React mounts
initSessionBridge().finally(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
